<template>
  <div>
    <div>
      <div v-if="is_dev" class="m-2 p-2 border-2">
        <div>DEV</div>
      </div>
      <div v-if="need_refresh" class="flex m-2 p-2 border-2 items-center">
        <div class="">NEED REFRESH PAGE</div>
        <div class="ml-8 tw_button">
          <button @click="onRefresh">REFRESH</button>
        </div>
      </div>

      <div class="mt-16"></div>

      <!-- header -->
      <div class="m-8 flex justify-between items-center">
        <motion.button
          :while-hover="{ scale: 1.2 }"
          :while-press="{ scale: 0.8 }"
          @click="router.push('/')"
        >
          <h1>NADO GAMES</h1>
        </motion.button>

        <div>
          <motion.button
            :while-hover="{ scale: 1.2 }"
            :while-press="{ scale: 0.8 }"
            @click="toggle_dark.apply()"
          >
            <div v-if="is_dark">
              <Icon class="tw_icon" icon="material-symbols:dark-mode-outline" />
            </div>
            <div v-else>
              <Icon class="tw_icon" icon="material-symbols:sunny-outline" />
            </div>
          </motion.button>
        </div>
      </div>

      <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/policy">Policy</router-link> |
  </nav>
  <hr /> -->

      <!-- banner -->
      <div class="banner">
        <!-- <img src="https://thisisone.github.io/jag/nado_banner.webp" /> -->
      </div>

      <div class="m-8 p-8 border-2 rounded-xl">
        <main>
          <router-view />
        </main>
      </div>

      <!-- footer -->
      <div class="grid grid-cols-2">
        <div class="m-4">
          <div class="h-8 font-bold">LINK</div>
          <a href="/policy" target="_blank">
            <div class="flex">
              <div class="mx-2">
                <Icon
                  class="w-6 h-6"
                  icon="material-symbols:privacy-tip-outline"
                />
              </div>
              <div class="h-8">PRIVACY POLICY</div>
            </div>
          </a>
        </div>

        <div class="m-4">
          <div class="h-8 font-bold">OTHER LINK</div>
          <div class="mt-2">
            <a
              href="https://play.google.com/store/apps/developer?id=NadoPJsoft"
              target="_blank"
            >
              <div class="flex">
                <div class="mx-2">
                  <Icon class="w-6 h-6" icon="nimbus:link" />
                </div>
                <div class="h-8">Play Store</div>
              </div>
            </a>

            <a href="https://nadoproject3rd.blogspot.com/" target="_blank">
              <div class="flex">
                <div class="mx-2">
                  <Icon class="w-6 h-6" icon="nimbus:link" />
                </div>
                <div class="h-8">Blog</div>
              </div>
            </a>

            <a href="https://www.patreon.com/cw/nadoproject" target="_blank">
              <div class="flex">
                <div class="mx-2">
                  <Icon class="w-6 h-6" icon="nimbus:link" />
                </div>
                <div class="h-8">Patreon</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="m-2 flex justify-end items-center">
        <div class="font-bold">v{{ VERSION }}</div>
        <div class="ml-2 text-xs">({{ moment(BUILD_DATE).fromNow() }})</div>
        <div class="ml-2 h-6 items-end">
          <iframe
            src="https://myhits.vercel.app/api/hit/https%3A%2F%2Fblockblast-bd3c9.web.app%2F?color=blue&label=hits&size=small"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// App.vue
import { useDark, useToggle } from "@vueuse/core";
import { Icon } from "@iconify/vue";
import { motion } from "motion-v";
import { useRouter } from "vue-router";
import { ref, computed, onMounted } from "vue";
import { VERSION, BUILD_DATE } from "@/ver";
import moment from "moment";
import * as Helper from "@/helper";

// firebase analytics
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
const firebaseConfig = {
  apiKey: "AIzaSyBXpBN2L5RpMHBnFrD7Gq19UreNX1inoKY",
  authDomain: "blockblast-bd3c9.firebaseapp.com",
  projectId: "blockblast-bd3c9",
  storageBucket: "blockblast-bd3c9.firebasestorage.app",
  messagingSenderId: "130806106861",
  appId: "1:130806106861:web:d406780dabb37289475ae4",
  measurementId: "G-TKM90TCK3Z",
};
const fb_app = initializeApp(firebaseConfig);
const fb_analytics = getAnalytics(fb_app);

const is_dev = computed(() => {
  return Helper.IS_DEV;
});
const need_refresh = ref(false);
const is_dark = useDark();
const toggle_dark = useToggle(is_dark);
const router = useRouter();
const url_banner = ref("/jag/nado_banner.webp");
const log_event = (msg) => {
  if (process.env.NODE_ENV == "development") return;
  // analytics 문서
  // https://firebase.google.com/docs/analytics/get-started?platform=web&authuser=0&hl=ko&_gl=1*1bdgo2i*_up*MQ..*_ga*MTA5Nzc3NTEzOC4xNzQ1MjQxOTYz*_ga_CW55HF8NVT*MTc0NTI0MTk2My4xLjEuMTc0NTI0MjQ3My40Mi4wLjA.
  logEvent(fb_analytics, msg);
};

if (Helper.IS_DEV == false) {
  console.log = () => {};
  console.info = () => {};
  console.error = () => {};
}

onMounted(async () => {
  console.log("VERSION", VERSION);

  log_event("web_start");

  try {
    var url = "https://thisisone.github.io/posts/bbg_web/bbg_web.json";
    var res = await Helper.web_get(url, {
      query: {
        t: new Date().toISOString(),
      },
    });
    if (res.status != 200) throw Error("status_fail_" + res.status);

    var data = res.data;
    // console.log("res_ok", data);
    console.log("release_version", data.release_version);
    if (data.release_version > VERSION) {
      // need refresh
      need_refresh.value = true;
    }

    // need_refresh.value = true;
  } catch (err) {
    console.error("bbg_web.json_fail", err.message);
  }
});

const onRefresh = () => {
  console.log("onRefresh");
  window.location.reload();
};
</script>

<style lscoped>
/* // */
.banner {
  background-image: url("https://thisisone.github.io/jag/nado_banner.webp");
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;

  height: 400px;
}
</style>
